import { _ as _classCallCheck } from './config-9cc484a4.esm.js';

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = o[Symbol.iterator]();
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function has(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

function omitNullValues(obj) {
  return Object.entries(obj).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    if (value !== null) acc[key] = value;
    return acc;
  }, {});
}
/**
 * Returns a combination of the loaded flags and the default flags.
 *
 * Tries to return the loaded flags directly in case the they contain all defaults
 * to avoid changing object references in the caller.
 *
 * @param rawFlags
 * @param defaultFlags
 */


function combineRawFlagsWithDefaultFlags(rawFlags, defaultFlags) {
  if (!rawFlags) return defaultFlags;
  var rawFlagsContainAllDefaultFlags = Object.keys(defaultFlags).every(function (key) {
    return has(rawFlags, key) && rawFlags[key] !== null;
  });
  return rawFlagsContainAllDefaultFlags ? rawFlags : _objectSpread2(_objectSpread2(_objectSpread2({}, rawFlags), defaultFlags), omitNullValues(rawFlags));
}
/**
 * Gets the cookie by the name
 *
 * From: https://developers.cloudflare.com/workers/examples/extract-cookie-value
 */

function getCookie(cookieString, name) {
  if (cookieString) {
    var cookies = cookieString.split(";");

    var _iterator = _createForOfIteratorHelper(cookies),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var cookie = _step.value;
        var cookiePair = cookie.split("=", 2);
        var cookieName = cookiePair[0].trim();
        if (cookieName === name) return cookiePair[1];
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return null;
}
function serializeVisitorKeyCookie(visitorKey) {
  // Max-Age 15552000 seconds equals 180 days
  return "hkvk=".concat(encodeURIComponent(visitorKey), "; Path=/; Max-Age=15552000; SameSite=Lax");
} // source: https://github.com/lukeed/dequal/blob/master/src/lite.js

function deepEqual(objA, objB) {
  var ctor, len;
  if (objA === objB) return true;

  if (objA && objB && (ctor = objA.constructor) === objB.constructor) {
    if (ctor === Date) return objA.getTime() === objB.getTime();
    if (ctor === RegExp) return objA.toString() === objB.toString();

    if (ctor === Array) {
      if ((len = objA.length) === objB.length) {
        while (len-- && deepEqual(objA[len], objB[len])) {
        }
      }

      return len === -1;
    }

    if (!ctor || _typeof(objA) === "object") {
      len = 0;

      for (ctor in objA) {
        if (has(objA, ctor) && ++len && !has(objB, ctor)) return false;
        if (!(ctor in objB) || !deepEqual(objA[ctor], objB[ctor])) return false;
      }

      return Object.keys(objB).length === len;
    }
  }

  return objA !== objA && objB !== objB;
}
var ObjectMap = /*#__PURE__*/function () {
  function ObjectMap() {
    _classCallCheck(this, ObjectMap);

    this.keys = [];
    this.values = [];
  }

  _createClass(ObjectMap, [{
    key: "_getIndex",
    value: function _getIndex(key) {
      return this.keys.findIndex(function (storedKey) {
        return deepEqual(key, storedKey);
      });
    }
  }, {
    key: "set",
    value: function set(key, value) {
      var index = this._getIndex(key);

      if (index == -1) {
        // "push" to front of arrays as more recently values are more likely
        // to be looked up again, and we want them to match early
        this.keys = [key].concat(_toConsumableArray(this.keys));
        this.values = [value].concat(_toConsumableArray(this.values));
      } else {
        this.values[index] = value;
      }
    }
  }, {
    key: "get",
    value: function get(key) {
      var index = this._getIndex(key);

      return index === -1 ? null : this.values[index];
    } // exists(key: Key) {
    //   return this.keys.some((storedKey) => deepEqual(storedKey, key));
    // }

    /** Resets the cache. For testing purposes. */

  }, {
    key: "clear",
    value: function clear() {
      this.keys = [];
      this.values = [];
    }
  }]);

  return ObjectMap;
}();

export { ObjectMap as O, _slicedToArray as _, _objectSpread2 as a, combineRawFlagsWithDefaultFlags as c, deepEqual as d, getCookie as g, has as h, serializeVisitorKeyCookie as s };
